import { useContext } from 'react';
import { NoContextError } from 'services/errors/NoContextError';
import { AppContext } from './AppContext';
import { DrawerContext } from './DrawerContext';
import { PatientDetailContext } from './PatientDetailContext';

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) throw new NoContextError(AppContext.displayName);
  return context;
};

export const useDrawerContext = () => {
  const context = useContext(DrawerContext);
  if (!context) throw new NoContextError(DrawerContext.displayName);
  return context;
};

export const usePatientDetailContext = () => {
  const context = useContext(PatientDetailContext);
  if (!context) throw new NoContextError(PatientDetailContext.displayName);
  return context;
};
